import React, {useState} from 'react'
import { Carousel } from 'react-bootstrap'
import { Popup } from '../../../../library/popup'
import { useSelector, useDispatch } from 'react-redux'
import { ToastContainer } from 'react-toastify'
import { TransparentButton, SolidButton } from '../../../../library/button'
import StepsView from './steps-view'
import SelectContainer from './select-container'
import ConfigureSMSContainer from './sms-config-container'
import ConfigureEmailContainer from './email-config-container'
import LoadingContainer from './final-container'
import { requestAddEmailChannel, requestAddSmsChannel, changeCampaignsModal } from '../../../../../redux/actions/campaigns'
import { sendErrorNotification } from '../../../../universal/notifications/notifications'
import './style.scss'

const Index = () => {

	const dispatch = useDispatch()

	const modalState = useSelector(state => state.campaigns.showModals.newChannelModal)

	const companyId = useSelector(state => state && state.activeCompany && state.activeCompany.activeCompany && state.activeCompany.activeCompany.id)

	const [stepProgress, setStepProgress] = useState(0)

	const [selectedType, setSelectedType] = useState("email")

    const [emailChannelConfiguration, setEmailChannelConfiguration] = useState({
        name: null,
    })

	const [smsConfiguration, setSmsConfiguration] = useState({
		name: null
	})

	const renderUploadProgress = () => {
        switch(stepProgress){
            case 0:
                return 5
            case 1:
                return 50
            case 2:
                return 100
            default:
                return 5
        }
    }

    const handleClose = () => {
		dispatch(changeCampaignsModal({newChannelModal: false}))
	}

	const clickNextSlide = () => {
		switch(stepProgress){
            case 0:
                if(selectedType){
                    setStepProgress(1)
                } else {
                    sendErrorNotification("Du må velge en kanal.")
                }
            break;
            case 1:
				if(selectedType === "email"){
					if(emailChannelConfiguration.name){
						setStepProgress(2)
						setTimeout(() => {
							dispatch(requestAddEmailChannel({companyId: companyId, details: emailChannelConfiguration}))
						}, 1000)
					} else {
						sendErrorNotification("Vennligst fyll inn alle felt.")
					}
				} else if(selectedType === "sms") {
					if(smsConfiguration.name){
						setStepProgress(2)
						setTimeout(() => {
							dispatch(requestAddSmsChannel({companyId: companyId, details: smsConfiguration}))
						}, 1000)
					} else {
						sendErrorNotification("Vennligst fyll inn brukernavn.")
					}
				}
            break;
            default:break
        }
	}
	

	return(
		<Popup 
			onClose={handleClose}
			show={modalState} 
			title="Opprett ny kanal"
			description="Du kan opprette en ny kanal og raskt komme i gang med e-postutsendelser ved å fylle inn feltene under."
			buttons={[
				<TransparentButton title="Avbryt" type="button" data-dismiss="modal" onClick={() => handleClose()} />,
				<SolidButton color="blue" title="Gå videre" onClick={() => clickNextSlide()} type="button"/>
			]}
		>
			<div className="add-channel-content-container">
				<StepsView stepProgress={stepProgress} renderUploadProgress={renderUploadProgress}/>
				<div className="modal-content-container">
                    <Carousel activeIndex={stepProgress} indicators={false} controls={false}>
					    <Carousel.Item className="selection-item">
                           <SelectContainer selectedType={selectedType} setSelectedType={setSelectedType}/>
						</Carousel.Item>
						<Carousel.Item>
							{selectedType === "email" ? 
								<ConfigureEmailContainer channelConfiguration={emailChannelConfiguration} setChannelConfiguration={setEmailChannelConfiguration}/>
								:
								<ConfigureSMSContainer smsConfiguration={smsConfiguration} setSmsConfiguration={setSmsConfiguration}/>
							}
						</Carousel.Item>
						<Carousel.Item className="selection-item">
                            <LoadingContainer selectedType={selectedType}/>
                        </Carousel.Item>
					</Carousel>
                </div>
			</div>
			<ToastContainer/>
		</Popup>
	)
}

export default Index
